import { Injectable } from '@angular/core';
import { observable } from 'mobx-angular';

@Injectable({
    providedIn: 'root'
})
export class Master {
    @observable SELECTED_FACULTY: any = null;
    @observable SELECTED_PROGRAM: any = null;
    

}
